import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';

// Auth checking is handled by AuthContext via API calls to /api/auth/get-session
// We don't use beforeLoad cookie checks because cookies may be HttpOnly
export const Route = createFileRoute('/_dashboard')({
  component: DashboardLayoutWrapper,
});

function DashboardLayoutWrapper() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
